/** Public inbox. No phone or street address. */
export const PUBLIC_CONTACT_EMAIL = 'info@sweetlisteners.com';
